import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { chartsTooltipClasses } from "@mui/x-charts";

const HorizontalBarChart = (props) => {
  const [height, setHeight] = useState(260);

  useEffect(() => {
    const updateFontSize = () => {
      if (window.innerWidth >= 2560) {
        setHeight(335);
      } else if (window.innerWidth < 2560 && window.innerWidth >= 2400) {
        setHeight(315);
      } else if (window.innerWidth < 2400 && window.innerWidth >= 2133) {
        setHeight(285);
      } else if (window.innerWidth < 2133 && window.innerWidth >= 1920) {
        setHeight(260);
      } else if (window.innerWidth < 1920 && window.innerWidth >= 1745) {
        setHeight(235);
      } else if (window.innerWidth < 1745 && window.innerWidth >= 1536) {
        setHeight(210);
      } else if (window.innerWidth < 1536 && window.innerWidth >= 1280) {
        setHeight(175);
      } else {
        setHeight(260);
      }
    };
    updateFontSize();
    window.addEventListener("resize", updateFontSize);

    return () => window.removeEventListener("resize", updateFontSize);
  }, []);

  const margin = {
    top: height * 0.015,
    right: height * 0.003,
    bottom: height * 0,
    left: height * 0.4,
  };

  return (
    <BarChart
      skipAnimation={false}
      height={height}
      borderRadius={4}
      layout="horizontal"
      grid={{ vertical: true }}
      xAxis={[
        {
          tickLabelStyle: {
            fontSize: "0.625em",
            fontWeight: "700",
            display: "none",
          },
          disableLine: true,
          disableTicks: true,
        },
      ]}
      yAxis={[
        {
          data: props?.ydata,
          scaleType: "band",
          categoryGapRatio: 0.4,
          barGapRatio: 0.6,
          disableTicks: true,
          disableLine: true,
          tickLabelStyle: {
            fontSize: "0.625em",
            fontWeight: "700",
            display: "none",
          },
        },
      ]}
      hideLegend={true}
      margin={margin}
      tooltip={{ trigger: "item" }}
      slotProps={{
        tooltip: {
          sx: {
            [`&.${chartsTooltipClasses.root} .${chartsTooltipClasses.valueCell}`]:
              {
                fontSize: height / 12,
              },
            [`&.${chartsTooltipClasses.root} .${chartsTooltipClasses.labelCell}`]:
              {
                fontSize: height / 14,
              },
          },
        },
      }}
      {...props}
    />
  );
};

export default HorizontalBarChart;
